import { render, staticRenderFns } from "./PropertySettings.vue?vue&type=template&id=04ab3c75&"
import script from "./PropertySettings.vue?vue&type=script&lang=js&"
export * from "./PropertySettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports